import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// TODO: Move container to a separate file
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { isUserLoggedIn } from 'apps/user/helpers';
import { closeMobileNav, setMobileNavLevel } from 'apps/topNavigation/actions/topNavigation';

import LoginButton from 'apps/header/components/LoginButton';
import RegisterButton from 'apps/header/components/RegisterButton';

import noAvatar from 'themes/[theme]/assets/images/no-avatar.jpg'; // eslint-disable-line import/order

class NavigationMenuHeader extends PureComponent {
  static propTypes = {
    closeMobileNav: PropTypes.func.isRequired,
    location: PropTypes.object,
    navMenuLevel: PropTypes.string.isRequired,
    setMobileNavLevel: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  };

  onBackClick = (event) => {
    event.preventDefault();
    this.props.setMobileNavLevel('root');
  };

  close = () => {
    this.props.closeMobileNav();
  };

  render() {
    const { user, navMenuLevel, location } = this.props;
    const { firstName, profilePicture } = user.customerDetails || {};
    const menuBack = (
      <button className="menu-back" onClick={this.onBackClick}>Back</button>
    );

    let userSection;
    const avatar = (
      <img
        className="profile-img"
        src={profilePicture || noAvatar}
        width="27"
        height="27"
        alt={firstName}
      />
    );
    if (isUserLoggedIn(user)) {
      userSection = (
        <div className="user-info section">
          {avatar}
          <span className="first-name">
            Hi {firstName}
          </span>
        </div>
      );
    } else {
      userSection = (
        <div className="signup-login section">
          <LoginButton
            onClick={this.close}
            className="btn-login"
            currentLocation={location}
          >
            Log in
          </LoginButton>
          <RegisterButton
            onClick={this.close}
            className="btn-signup"
            currentLocation={location}
          >
            Register
          </RegisterButton>
        </div>
      );
    }

    return (
      <div className="navigation-header">
        {navMenuLevel === 'root' ? userSection : menuBack}
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      user: state.user,
    }),
    {
      closeMobileNav,
      setMobileNavLevel,
    },
  )(NavigationMenuHeader)
);
